import Tooltip from "@/components/atoms/Tooltip/Tooltip";
import { useTranslation } from "@repo/shared/i18n";
import { isMobile } from "react-device-detect";

import { metaRatingLogoLabel, simpleInfoIcon } from "../../../../icons";

export const MetaRatingTooltip = () => {
  const { t } = useTranslation("squadBuilder");
  return (
    <Tooltip
      content={
        <div className="flex flex-col text-sm text-white gap-y-2 w-64">
          <div className="w-36">{metaRatingLogoLabel}</div>
          <p>
            {t("metaRatingTooltip.performance")} <br />
            <br />
            {t("metaRatingTooltip.calculation")}
          </p>
        </div>
      }
      side={isMobile ? "bottom" : "right"}
      delayDuration={100}
    >
      <div className="w-4 h-4 text-white">{simpleInfoIcon}</div>
    </Tooltip>
  );
};
